import axios, { type AxiosResponse } from "axios";
import {
  BusinessUnitResultSchema,
  BusinessUnitItemSchema,
  BusinessUnitHardwareItemSchema,
  BusinessUnitLicenseItemSchema,
} from "@/schemas/index";
import type {
  BusinessUnitResultType,
  BusinessUnitItemType,
  BusinessUnitHardwareItemType,
  BusinessUnitLicenseItemType,
} from "@/schemas/index";
import env from "@/app/config/env";

export interface ServiceBusinessUnitsApiType {
  fetchBusinessUnits: (
    pageIndex?: number,
    pageSize?: number,
    query?: string,
  ) => Promise<BusinessUnitResultType>;
  fetchBusinessUnitById: (
    id: BusinessUnitItemType["Id"],
  ) => Promise<BusinessUnitItemType>;
  fetchUpdateBusinessUnit: (
    params: Partial<BusinessUnitItemType>,
  ) => Promise<void>;
  fetchCreateBusinessUnit: (
    params: Partial<BusinessUnitItemType>,
  ) => Promise<BusinessUnitItemType>;
  fetchBusinessUnitHardware: (
    businessUnitId: BusinessUnitItemType["Id"],
  ) => Promise<BusinessUnitHardwareItemType[]>;

  fetchBusinessUnitLicenses: (
    businessUnitId: BusinessUnitItemType["Id"],
  ) => Promise<BusinessUnitLicenseItemType[]>;

  fetchUpdateBusinessUnitLicenses: (
    businessUnitId: BusinessUnitItemType["Id"],
    licensesIds: string[],
  ) => Promise<void>;
}

export const serviceBusinessUnitsApi: ServiceBusinessUnitsApiType = {
  fetchBusinessUnits: (pageIndex, pageSize, query) => {
    return axios
      .get(`${env.services.portal}/businessunits`, {
        params: {
          pageIndex: pageIndex,
          pageSize: pageSize,
          query: query || "",
        },
      })
      .then((response: AxiosResponse<unknown>) => {
        return BusinessUnitResultSchema.parse(response.data);
      });
  },

  fetchBusinessUnitById: (id) => {
    return axios
      .get(`${env.services.portal}/businessunits/${id}`)
      .then((response: AxiosResponse<unknown>) => {
        return BusinessUnitItemSchema.parse(response.data);
      });
  },

  fetchCreateBusinessUnit: (params) => {
    return axios
      .post(`${env.services.portal}/businessunits`, params)
      .then((response: AxiosResponse<unknown>) => {
        return BusinessUnitItemSchema.parse(response.data);
      });
  },

  fetchUpdateBusinessUnit: (params) =>
    axios.patch(`${env.services.portal}/businessunits/${params.Id}`, params),

  fetchBusinessUnitHardware: (businessUnitId) => {
    return axios
      .get(`${env.services.portal}/businessunits/${businessUnitId}/hardware`)
      .then((response: AxiosResponse<unknown[]>) => {
        return response.data.map((item: unknown) =>
          BusinessUnitHardwareItemSchema.parse(item),
        );
      });
  },

  fetchUpdateBusinessUnitLicenses: (businessUnitId, licensesIds) => {
    return axios.patch(
      `${env.services.portal}/businessunits/${businessUnitId}/licenses`,
      { LicensesIds: licensesIds },
    );
  },

  fetchBusinessUnitLicenses: (businessUnitId) => {
    return axios
      .get(`${env.services.portal}/businessunits/${businessUnitId}/licenses`)
      .then((response: AxiosResponse<unknown[]>) => {
        return response.data.map((item: unknown) =>
          BusinessUnitLicenseItemSchema.parse(item),
        );
      });
  },
};
